import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'zikata-frontend-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {

  @Input() title: string | undefined;
  @Input() description: string | undefined;
  @Input() buttonActionLabel: string | undefined;
  @Input() isLoading = false;
  @Input() resendEmailUrl = '';
  @Output() goBack: EventEmitter<undefined> = new EventEmitter<undefined>();
  @Output() formSubmit: EventEmitter<undefined> = new EventEmitter<undefined>();

  forgotPasswordForm: FormGroup = new FormGroup({ email: new FormControl('', [Validators.required, Validators.email])});

  errorMessage = '';

  onFormSubmit() {
    if(this.forgotPasswordForm.invalid) {
      this.errorMessage = "Please fill in your email address";
      return;
    }
    this.errorMessage = '';
    this.formSubmit.emit(this.forgotPasswordForm.controls['email'].value);
  }

}
